import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { dropdownValuesConstants } from "./dropdownValues.constants";
import {
	newRequestState,
	newSuccessState,
	newErrorState,
} from "../baseReducers";

// On Review: remove reducer/actions/constants, use react-query
const initialState = {
	loading: {
		merchantStatuses: false,
		companies: false,
		companyUsers: false,
		feeTemplate: false,
		terminalManufacturers: false,
		terminalModels: false,
		terminalAccessoryTypes: false,
		terminalDeviceTypes: false,
		terminalProgramTypes: false,
		merchantTimeZone: false,
		tidRequestStatuses: false,
	},
	error: {
		merchantStatuses: "",
		companies: "",
		companyUsers: "",
		feeTemplate: "",
		terminalManufacturers: "",
		terminalModels: "",
		terminalDeviceTypes: "",
		terminalAccessoryTypes: "",
		terminalProgramTypes: "",
	},
	merchantStatuses: [],
	companies: [],
	companyUsers: [],
	feeTemplate: [],
	terminalManufacturers: [],
	terminalModels: [],
	terminalAccessoryTypes: [],
	terminalDeviceTypes: [],
	terminalProgramTypes: [],
	merchantTimeZone: [],
	pdfTemplates: [],
	pendStatuses: [],
};

export const getDropDownState = state => state.dropdownValues;

const selector = property => fp.flow(getDropDownState, fp.get(property));

export const getCompanies = selector("companies");

function dropdownValues(state = initialState, action) {
	switch (action.type) {
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PROCESSORS_REQUEST: {
			return newRequestState(state, "processors");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PROCESSORS_SUCCESS: {
			let converteToStringArray = action.processors.map(item => {
				return {
					name: item.name,
					id: item.id.toString(),
				};
			});

			return newSuccessState(state, "processors", converteToStringArray);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PROCESSORS_ERROR: {
			return newErrorState(state, "processors", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_SPONSORS_REQUEST: {
			return newRequestState(state, "sponsors");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_SPONSORS_SUCCESS: {
			let converteToStringArray = action.sponsors.map(item => {
				return {
					name: item.name,
					type: item.type,
					id: item.id.toString(),
				};
			});
			return newSuccessState(state, "sponsors", converteToStringArray);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_SPONSORS_ERROR: {
			return newErrorState(state, "sponsors", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_REQUEST: {
			return newRequestState(state, "pdfTemplates");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_SUCCESS: {
			return newSuccessState(state, "pdfTemplates", action.pdfTemplates);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_ERROR: {
			return newErrorState(state, "pdfTemplates", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_REQUEST: {
			return newRequestState(state, "merchantStatuses");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_SUCCESS: {
			return newSuccessState(
				state,
				"merchantStatuses",
				action.merchantStatuses,
			);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_ERROR: {
			return newErrorState(state, "merchantStatuses", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_REQUEST: {
			return newRequestState(state, "companies");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_SUCCESS: {
			return newSuccessState(state, "companies", action.companies);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_ERROR: {
			return newErrorState(state, "companies", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANY_USERS_REQUEST: {
			return newRequestState(state, "companyUsers");
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANY_USERS_SUCCESS: {
			return newSuccessState(state, "companyUsers", action.companyUsers);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANY_USERS_ERROR: {
			return newErrorState(state, "companyUsers", action.error, []);
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_REQUEST: {
			const withTerminalModels = newRequestState(state, "terminalModels");
			const withManufacturers = newRequestState(
				withTerminalModels,
				"terminalManufacturers",
			);
			return withManufacturers;
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_SUCCESS: {
			const withTerminalModels = newSuccessState(
				state,
				"terminalModels",
				action.terminals.terminalModels,
			);
			const withManufacturers = newSuccessState(
				withTerminalModels,
				"terminalManufacturers",
				action.terminals.terminalManufacturers,
			);

			const withAccessoryTypes = newSuccessState(
				withManufacturers,
				"terminalAccessoryTypes",
				action.terminals.terminalAccessoryTypes,
			);

			const withDeviceTypes = newSuccessState(
				withAccessoryTypes,
				"terminalDeviceTypes",
				action.terminals.terminalDeviceTypes,
			);
			return withDeviceTypes;
		}
		case dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_ERROR: {
			const withTerminalModels = newErrorState(
				state,
				"terminalModels",
				action.error,
				[],
			);
			const withManufacturers = newErrorState(
				withTerminalModels,
				"terminalManufacturers",
				action.error,
				[],
			);
			return withManufacturers;
		}
		case dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_REQUEST: {
			return newRequestState(state, "merchantTimeZone");
		}
		case dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_SUCCESS: {
			return newSuccessState(state, "merchantTimeZone", [
				action.merchantTimeZone,
			]);
		}
		case dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_ERROR: {
			return newErrorState(state, "merchantTimeZone", action.error, []);
		}
		default:
			return state;
	}
}

export default withResetState({ initialState })(dropdownValues);
